module.exports = __webpack_public_path__ + "static/media/distribuicao-1.2e60828e.jpg";